import React from "react";
import { Dropdown} from "react-bootstrap";


export const dropdownSortOptions = [
    { label: "Created", value: "_id" },
    { label: "Start", value: "startDate" },
    { label: "End", value: "endDate" },
    { label: "Alphabetical", value: "name" },
];
export const DropdownSort = ({optionSelected, toggleOrder, selectedOption, isAscending}) => {

    return (
        <Dropdown>
            <Dropdown.Toggle variant="link" style={{color:"#515151"}}>
                {selectedOption} ({isAscending ? "+" : "-"})
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {dropdownSortOptions.map((option) => (
                    <Dropdown.Item  onClick={() => optionSelected(option.label)}>
                        {option.label}
                    </Dropdown.Item>
                ))}
                <Dropdown.Divider/>
                <Dropdown.Item  onClick={toggleOrder}>
                    {isAscending ? "Switch to Decreasing" : "Switch to Increasing"}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};
